import { Code2 } from "lucide-react";
import { type ReactNode, useId } from "react";

function CursorIcon({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 466.73 532.09"
			fill="currentColor"
			className={className}
			aria-hidden="true"
		>
			<path d="M457.43,125.94L244.42,2.96c-6.84-3.95-15.28-3.95-22.12,0L9.3,125.94c-5.75,3.32-9.3,9.46-9.3,16.11v247.99c0,6.65,3.55,12.79,9.3,16.11l213.01,122.98c6.84,3.95,15.28,3.95,22.12,0l213.01-122.98c5.75-3.32,9.3-9.46,9.3-16.11v-247.99c0-6.65-3.55-12.79-9.3-16.11h-.01ZM444.05,151.99l-205.63,356.16c-1.39,2.4-5.06,1.42-5.06-1.36v-233.21c0-4.66-2.49-8.97-6.53-11.31L24.87,145.67c-2.4-1.39-1.42-5.06,1.36-5.06h411.26c5.84,0,9.49,6.33,6.57,11.39h-.01Z" />
		</svg>
	);
}

function WindsurfIcon({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 1024 1024"
			fill="currentColor"
			className={className}
			aria-hidden="true"
		>
			<path d="M897.246 286.869H889.819C850.735 286.808 819.017 318.46 819.017 357.539V515.589C819.017 547.15 792.93 572.716 761.882 572.716C743.436 572.716 725.02 563.433 714.093 547.85L552.673 317.304C539.28 298.16 517.486 286.747 493.895 286.747C457.094 286.747 423.976 318.034 423.976 356.657V515.619C423.976 547.181 398.103 572.746 366.842 572.746C348.335 572.746 329.949 563.463 319.021 547.881L138.395 289.882C134.316 284.038 125.154 286.93 125.154 294.052V431.892C125.154 438.862 127.285 445.619 131.272 451.34L309.037 705.2C319.539 720.204 335.033 731.344 352.9 735.392C397.616 745.557 438.77 711.135 438.77 667.278V508.406C438.77 476.845 464.339 451.279 495.904 451.279H495.995C515.02 451.279 532.857 460.562 543.785 476.145L705.235 706.661C718.659 725.835 739.327 737.218 763.983 737.218C801.606 737.218 833.841 705.9 833.841 667.308V508.376C833.841 476.815 859.41 451.249 890.975 451.249H897.276C901.233 451.249 904.43 448.053 904.43 444.097V294.021C904.43 290.065 901.233 286.869 897.276 286.869H897.246Z" />
		</svg>
	);
}

function ClaudeIcon({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 256 257"
			preserveAspectRatio="xMidYMid"
			fill="currentColor"
			className={className}
			aria-hidden="true"
		>
			<path d="m50.228 170.321 50.357-28.257.843-2.463-.843-1.361h-2.462l-8.426-.518-28.775-.778-24.952-1.037-24.175-1.296-6.092-1.297L0 125.796l.583-3.759 5.12-3.434 7.324.648 16.202 1.101 24.304 1.685 17.629 1.037 26.118 2.722h4.148l.583-1.685-1.426-1.037-1.101-1.037-25.147-17.045-27.22-18.017-14.258-10.37-7.713-5.25-3.888-4.925-1.685-10.758 7-7.713 9.397.649 2.398.648 9.527 7.323 20.35 15.75L94.817 91.9l3.889 3.24 1.555-1.102.195-.777-1.75-2.917-14.453-26.118-15.425-26.572-6.87-11.018-1.814-6.61c-.648-2.723-1.102-4.991-1.102-7.778l7.972-10.823L71.42 0 82.05 1.426l4.472 3.888 6.61 15.101 10.694 23.786 16.591 32.34 4.861 9.592 2.592 8.879.973 2.722h1.685v-1.556l1.36-18.211 2.528-22.36 2.463-28.776.843-8.1 4.018-9.722 7.971-5.25 6.222 2.981 5.12 7.324-.713 4.73-3.046 19.768-5.962 30.98-3.889 20.739h2.268l2.593-2.593 10.499-13.934 17.628-22.036 7.778-8.749 9.073-9.657 5.833-4.601h11.018l8.1 12.055-3.628 12.443-11.342 14.388-9.398 12.184-13.48 18.147-8.426 14.518.778 1.166 2.01-.194 30.46-6.481 16.462-2.982 19.637-3.37 8.88 4.148.971 4.213-3.5 8.62-20.998 5.184-24.628 4.926-36.682 8.685-.454.324.519.648 16.526 1.555 7.065.389h17.304l32.21 2.398 8.426 5.574 5.055 6.805-.843 5.184-12.962 6.611-17.498-4.148-40.83-9.721-14-3.5h-1.944v1.167l11.666 11.406 21.387 19.314 26.767 24.887 1.36 6.157-3.434 4.86-3.63-.518-23.526-17.693-9.073-7.972-20.545-17.304h-1.36v1.814l4.73 6.935 25.017 37.59 1.296 11.536-1.814 3.76-6.481 2.268-7.13-1.297-14.647-20.544-15.1-23.138-12.185-20.739-1.49.843-7.194 77.448-3.37 3.953-7.778 2.981-6.48-4.925-3.436-7.972 3.435-15.749 4.148-20.544 3.37-16.333 3.046-20.285 1.815-6.74-.13-.454-1.49.194-15.295 20.999-23.267 31.433-18.406 19.702-4.407 1.75-7.648-3.954.713-7.064 4.277-6.286 25.47-32.405 15.36-20.092 9.917-11.6-.065-1.686h-.583L44.07 198.125l-12.055 1.555-5.185-4.86.648-7.972 2.463-2.593 20.35-13.999-.064.065Z" />
		</svg>
	);
}

function PathIcon({
	viewBox = "0 0 24 24",
	d,
	className,
	fillRule,
	clipRule,
}: {
	viewBox?: string;
	d: string;
	className?: string;
	fillRule?: "evenodd" | "nonzero";
	clipRule?: "evenodd" | "nonzero";
}) {
	return (
		<svg
			viewBox={viewBox}
			fill="currentColor"
			className={className}
			aria-hidden="true"
		>
			<path d={d} fillRule={fillRule} clipRule={clipRule} />
		</svg>
	);
}

function OpenclawIcon({ className }: { className?: string }) {
	const rawId = useId();
	const gradientId = `openclaw-gradient-${rawId.replace(/[:]/g, "")}`;
	return (
		<svg
			viewBox="0 0 120 120"
			fill="none"
			className={className}
			aria-hidden="true"
		>
			<defs>
				<linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="#ff4d4d" />
					<stop offset="100%" stopColor="#991b1b" />
				</linearGradient>
			</defs>
			<path
				d="M60 10 C30 10 15 35 15 55 C15 75 30 95 45 100 L45 110 L55 110 L55 100 C55 100 60 102 65 100 L65 110 L75 110 L75 100 C90 95 105 75 105 55 C105 35 90 10 60 10Z"
				fill={`url(#${gradientId})`}
			/>
			<path
				d="M20 45 C5 40 0 50 5 60 C10 70 20 65 25 55 C28 48 25 45 20 45Z"
				fill={`url(#${gradientId})`}
			/>
			<path
				d="M100 45 C115 40 120 50 115 60 C110 70 100 65 95 55 C92 48 95 45 100 45Z"
				fill={`url(#${gradientId})`}
			/>
			<path
				d="M45 15 Q35 5 30 8"
				stroke="#ff4d4d"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<path
				d="M75 15 Q85 5 90 8"
				stroke="#ff4d4d"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<circle cx="45" cy="35" r="6" fill="#050810" />
			<circle cx="75" cy="35" r="6" fill="#050810" />
			<circle cx="46" cy="34" r="2.5" fill="#00e5cc" />
			<circle cx="76" cy="34" r="2.5" fill="#00e5cc" />
		</svg>
	);
}

function GeminiIcon({ className }: { className?: string }) {
	const rawId = useId();
	const base = `gemini-${rawId.replace(/[:]/g, "")}`;
	const ids = {
		mask: `${base}-mask`,
		b: `${base}-b`,
		c: `${base}-c`,
		d: `${base}-d`,
		e: `${base}-e`,
		f: `${base}-f`,
		g: `${base}-g`,
		h: `${base}-h`,
	};
	return (
		<svg
			viewBox="0 0 296 298"
			fill="none"
			className={className}
			aria-hidden="true"
		>
			<mask
				id={ids.mask}
				width="296"
				height="298"
				x="0"
				y="0"
				maskUnits="userSpaceOnUse"
				style={{ maskType: "alpha" }}
			>
				<path
					fill="#3186FF"
					d="M141.201 4.886c2.282-6.17 11.042-6.071 13.184.148l5.985 17.37a184.004 184.004 0 0 0 111.257 113.049l19.304 6.997c6.143 2.227 6.156 10.91.02 13.155l-19.35 7.082a184.001 184.001 0 0 0-109.495 109.385l-7.573 20.629c-2.241 6.105-10.869 6.121-13.133.025l-7.908-21.296a184 184 0 0 0-109.02-108.658l-19.698-7.239c-6.102-2.243-6.118-10.867-.025-13.132l20.083-7.467A183.998 183.998 0 0 0 133.291 26.28l7.91-21.394Z"
				/>
			</mask>
			<g mask={`url(#${ids.mask})`}>
				<g filter={`url(#${ids.b})`}>
					<ellipse cx="163" cy="149" fill="#3689FF" rx="196" ry="159" />
				</g>
				<g filter={`url(#${ids.c})`}>
					<ellipse cx="33.5" cy="142.5" fill="#F6C013" rx="68.5" ry="72.5" />
				</g>
				<g filter={`url(#${ids.d})`}>
					<ellipse cx="19.5" cy="148.5" fill="#F6C013" rx="68.5" ry="72.5" />
				</g>
				<g filter={`url(#${ids.e})`}>
					<path
						fill="#FA4340"
						d="M194 10.5C172 82.5 65.5 134.333 22.5 135L144-66l50 76.5Z"
					/>
				</g>
				<g filter={`url(#${ids.f})`}>
					<path
						fill="#FA4340"
						d="M190.5-12.5C168.5 59.5 62 111.333 19 112L140.5-89l50 76.5Z"
					/>
				</g>
				<g filter={`url(#${ids.g})`}>
					<path
						fill="#14BB69"
						d="M194.5 279.5C172.5 207.5 66 155.667 23 155l121.5 201 50-76.5Z"
					/>
				</g>
				<g filter={`url(#${ids.h})`}>
					<path
						fill="#14BB69"
						d="M196.5 320.5C174.5 248.5 68 196.667 25 196l121.5 201 50-76.5Z"
					/>
				</g>
			</g>
			<defs>
				<filter
					id={ids.b}
					width="464"
					height="390"
					x="-69"
					y="-46"
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="18" />
				</filter>
				<filter
					id={ids.c}
					width="265"
					height="273"
					x="-99"
					y="6"
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="32" />
				</filter>
				<filter
					id={ids.d}
					width="265"
					height="273"
					x="-113"
					y="12"
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="32" />
				</filter>
				<filter
					id={ids.e}
					width="299.5"
					height="329"
					x="-41.5"
					y="-130"
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="32" />
				</filter>
				<filter
					id={ids.f}
					width="299.5"
					height="329"
					x="-45"
					y="-153"
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="32" />
				</filter>
				<filter
					id={ids.g}
					width="299.5"
					height="329"
					x="-41"
					y="91"
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="32" />
				</filter>
				<filter
					id={ids.h}
					width="299.5"
					height="329"
					x="-39"
					y="132"
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feGaussianBlur stdDeviation="32" />
				</filter>
			</defs>
		</svg>
	);
}

export type AgentKey =
	| "claude"
	| "claude-code"
	| "chatgpt"
	| "openai"
	| "cursor"
	| "openclaw"
	| "windsurf"
	| "codex"
	| "gemini";

export const AGENT_ICONS: Record<AgentKey, (className: string) => ReactNode> = {
	claude: (c) => <ClaudeIcon className={c} />,
	"claude-code": (c) => <ClaudeIcon className={c} />,
	chatgpt: (c) => (
		<PathIcon
			d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.911 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.182a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.998-2.9 6.056 6.056 0 0 0-.748-7.073zm-9.022 12.608a4.476 4.476 0 0 1-2.876-1.04l.142-.08 4.778-2.759a.778.778 0 0 0 .393-.681v-6.737l2.02 1.169a.072.072 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.495 4.494zm-9.66-4.125a4.471 4.471 0 0 1-.535-3.014l.142.085 4.783 2.758a.771.771 0 0 0 .78 0l5.843-3.369v2.333a.08.08 0 0 1-.033.061l-4.832 2.788a4.499 4.499 0 0 1-6.141-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.677l5.814 3.354-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.596 3.856L13.103 8.36l2.016-1.16a.076.076 0 0 1 .07 0l4.831 2.79a4.494 4.494 0 0 1-.677 8.105v-5.677a.79.79 0 0 0-.407-.667zm2.011-3.023-.142-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.062l4.83-2.786a4.499 4.499 0 0 1 6.68 4.66zM8.307 12.863l-2.02-1.164a.08.08 0 0 1-.038-.057V6.074a4.499 4.499 0 0 1 7.376-3.453l-.142.08-4.778 2.758a.778.778 0 0 0-.393.682zm1.097-2.366 2.602-1.5 2.607 1.5v3l-2.597 1.5-2.607-1.5z"
			className={c}
		/>
	),
	openai: (c) => (
		<PathIcon
			d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.911 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.182a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.998-2.9 6.056 6.056 0 0 0-.748-7.073zm-9.022 12.608a4.476 4.476 0 0 1-2.876-1.04l.142-.08 4.778-2.759a.778.778 0 0 0 .393-.681v-6.737l2.02 1.169a.072.072 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.495 4.494zm-9.66-4.125a4.471 4.471 0 0 1-.535-3.014l.142.085 4.783 2.758a.771.771 0 0 0 .78 0l5.843-3.369v2.333a.08.08 0 0 1-.033.061l-4.832 2.788a4.499 4.499 0 0 1-6.141-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.677l5.814 3.354-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.596 3.856L13.103 8.36l2.016-1.16a.076.076 0 0 1 .07 0l4.831 2.79a4.494 4.494 0 0 1-.677 8.105v-5.677a.79.79 0 0 0-.407-.667zm2.011-3.023-.142-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.062l4.83-2.786a4.499 4.499 0 0 1 6.68 4.66zM8.307 12.863l-2.02-1.164a.08.08 0 0 1-.038-.057V6.074a4.499 4.499 0 0 1 7.376-3.453l-.142.08-4.778 2.758a.778.778 0 0 0-.393.682zm1.097-2.366 2.602-1.5 2.607 1.5v3l-2.597 1.5-2.607-1.5z"
			className={c}
		/>
	),
	cursor: (c) => <CursorIcon className={c} />,
	openclaw: (c) => <OpenclawIcon className={c} />,
	windsurf: (c) => <WindsurfIcon className={c} />,
	codex: (c) => (
		<PathIcon
			d="M8.086.457a6.105 6.105 0 013.046-.415c1.333.153 2.521.72 3.564 1.7a.117.117 0 00.107.029c1.408-.346 2.762-.224 4.061.366l.063.03.154.076c1.357.703 2.33 1.77 2.918 3.198.278.679.418 1.388.421 2.126a5.655 5.655 0 01-.18 1.631.167.167 0 00.04.155 5.982 5.982 0 011.578 2.891c.385 1.901-.01 3.615-1.183 5.14l-.182.22a6.063 6.063 0 01-2.934 1.851.162.162 0 00-.108.102c-.255.736-.511 1.364-.987 1.992-1.199 1.582-2.962 2.462-4.948 2.451-1.583-.008-2.986-.587-4.21-1.736a.145.145 0 00-.14-.032c-.518.167-1.04.191-1.604.185a5.924 5.924 0 01-2.595-.622 6.058 6.058 0 01-2.146-1.781c-.203-.269-.404-.522-.551-.821a7.74 7.74 0 01-.495-1.283 6.11 6.11 0 01-.017-3.064.166.166 0 00.008-.074.115.115 0 00-.037-.064 5.958 5.958 0 01-1.38-2.202 5.196 5.196 0 01-.333-1.589 6.915 6.915 0 01.188-2.132c.45-1.484 1.309-2.648 2.577-3.493.282-.188.55-.334.802-.438.286-.12.573-.22.861-.304a.129.129 0 00.087-.087A6.016 6.016 0 015.635 2.31C6.315 1.464 7.132.846 8.086.457zm-.804 7.85a.848.848 0 00-1.473.842l1.694 2.965-1.688 2.848a.849.849 0 001.46.864l1.94-3.272a.849.849 0 00.007-.854l-1.94-3.393zm5.446 6.24a.849.849 0 000 1.695h4.848a.849.849 0 000-1.696h-4.848z"
			fillRule="evenodd"
			clipRule="evenodd"
			className={c}
		/>
	),
	gemini: (c) => <GeminiIcon className={c} />,
};

export const AGENT_ACCENTS: Record<AgentKey, { text: string; bg: string }> = {
	claude: { text: "text-[#D97757]", bg: "bg-[#D97757]/10" },
	"claude-code": { text: "text-[#D97757]", bg: "bg-[#D97757]/10" },
	chatgpt: { text: "text-[#10A37F]", bg: "bg-[#10A37F]/10" },
	openai: { text: "text-foreground", bg: "bg-foreground/10" },
	cursor: { text: "text-foreground", bg: "bg-foreground/10" },
	openclaw: { text: "text-red-500", bg: "bg-red-500/10" },
	windsurf: { text: "text-sky-500", bg: "bg-sky-500/10" },
	codex: { text: "text-foreground", bg: "bg-foreground/10" },
	gemini: { text: "text-blue-500", bg: "bg-blue-500/10" },
};

export { Code2 };
